import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SOURCE_EMAIL, SOURCE } from '@whitelabel/xcover-shared/helpers/constants';
import { storeCustomerRegionFromURL, configureCognito } from '@whitelabel/xcover-shared/helpers/multiRegion';
import { validateSignUpToken, logout } from '../../actions';
import { RootState } from '../../store';

// This signupToken is for normal user signup.
const useSignupModal = (openLoginModal: () => void) => {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const id = urlParams.get('id') || '';
  const signupToken = urlParams.get('signup_token') || '';
  const source = urlParams.get(SOURCE) || SOURCE_EMAIL;
  const dispatch = useDispatch();
  const userState = useSelector(({ user }: RootState) => user);

  useEffect(() => {
    storeCustomerRegionFromURL();
    configureCognito();
  }, []);

  useEffect(() => {
    if (id && signupToken && userState.data && userState.data.username !== id) {
      dispatch(logout());
    }
  }, []);

  const [isSignupModalOpen, setSignupModalOpen] = useState(false);
  const toggle = () => {
    setSignupModalOpen((modalOpen: boolean) => !modalOpen);
  };

  useEffect(() => {
    if (id && signupToken && !userState.data) {
      const onError = (error: { status: number }) => {
        if (error.status === 422) {
          openLoginModal();
        }
      };

      const onSuccess = () => {
        setSignupModalOpen(true);
      };
      dispatch(validateSignUpToken({ id, token: signupToken, source, onError, onSuccess }));
    }
    // only auto valiate when component mount
  }, [userState.data]);

  return [isSignupModalOpen, toggle] as const;
};

export default useSignupModal;
